/** Live SVG cross-section: regions colored by εr, conductors, guides, labels. */
import { epsilonColor } from "../lib/colormap";
import { schem } from "../state/store";

export function SchematicView() {
  const s = schem.value;
  const pad = s.halfSpan * 0.12;
  const half = s.halfSpan + pad;
  const lw = s.halfSpan / 120;
  const fontSize = s.halfSpan / 8;

  // Legend: unique εr values.
  const ers = [...new Set(s.regions.map((r) => r.er))].sort((a, b) => a - b);

  return (
    <div class="schematic">
      <svg viewBox={`${-half} ${-half} ${2 * half} ${2 * half}`}>
        {/* y-up geometry: flip so +y renders upward */}
        <g transform="scale(1,-1)">
          {s.regions.map((r, i) => (
            <path key={i} d={r.path} fill={epsilonColor(r.er)} fill-rule="evenodd" stroke="none" />
          ))}
          {s.guides.map((g, i) =>
            g.type === "circle" ? (
              <circle key={i} cx={g.cx} cy={0} r={g.r} fill="none" stroke="var(--text-secondary)" stroke-width={lw / 2} stroke-dasharray={`${lw * 3} ${lw * 2}`} />
            ) : (
              <line key={i} x1={g.x0} y1={g.y0} x2={g.x1} y2={g.y1} stroke="var(--text-secondary)" stroke-width={lw / 2} stroke-dasharray={`${lw * 3} ${lw * 2}`} />
            ),
          )}
          <circle cx={s.inner.cx} cy={0} r={s.inner.r} fill="var(--signal)" fill-opacity={0.9} stroke="#8e0000" stroke-width={lw} />
          <circle cx={0} cy={0} r={s.outer.r} fill="none" stroke="var(--text)" stroke-width={lw * 2} />
          {s.regions.map((r, i) => (
            <text
              key={`t${i}`}
              x={r.labelX}
              y={-r.labelY}
              transform="scale(1,-1)"
              text-anchor="middle"
              dominant-baseline="middle"
              font-size={fontSize}
              fill="var(--text)"
            >
              {`εr ${r.er}`}
            </text>
          ))}
        </g>
      </svg>
      <div class="schematic-legend">
        {ers.map((er) => (
          <span key={er} class="legend-item">
            <span class="legend-swatch" style={{ background: epsilonColor(er) }} />
            εr = {er}
          </span>
        ))}
        <span class="legend-item">
          <span class="legend-swatch" style={{ background: "var(--signal)" }} />
          signal
        </span>
      </div>
    </div>
  );
}
